import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
} from '@mui/lab';
import { Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';

const CompanyHistory = () => {
  const timelineData = [
    { date: 'Sep 2023', event: 'First Freelance Web Project' },
    { date: 'Dec 2023', event: 'Website & SEO for Pushti Amrittulya' },
    { date: 'Jan 2024', event: 'UI/UX Website Design for 4Prosper Technologies' },
    { date: 'Feb 2024', event: 'UI/UX for MKG MegaFoods (DevPriya Group)' },
    { date: 'Mar 2024', event: 'Event Management Platform for Bilans' },
    { date: 'May 2024', event: 'UI/UX & Website for Shri Balaji Cement Products' },
    { date: 'Jun 2024', event: 'UI/UX & Website for Shree Bajrang Precast' },
    { date: 'July 2024', event: 'UI/UX for FyndCareers' },
    { date: 'Jan 2025', event: 'Ecommerce for Kayna - Shopify' },
    { date: 'Feb 2025', event: 'Ecommerce for Omidza - Shopify' },
  ];

  return (
    <Box className="company-history" display="flex" flexWrap="wrap" gap={4} sx={{mt:0}}>
      <motion.div
        className="history-column"
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
        style={{ flex: 1 }}
      >
        <Typography variant="h3" textAlign={'left'} fontWeight={'medium'} className="history-title" gutterBottom>
          From Freelance Beginnings <br />
          to Scalable Innovation
        </Typography>
        <Typography className="history-description" textAlign={'left'}>
          We've spent the past two years crafting tailored solutions for startups just like yours. <br />
          Today, <span className="highlight">Vionex Labs</span> brings together a curated network of designers, engineers, and strategists—working collaboratively to scale your vision without compromising on speed, quality, or budget.
        </Typography>
      </motion.div>

      <motion.div
        className="timeline-column"
        style={{ flex: 1 }}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.18
            }
          }
        }}
      >
        <Timeline position="alternate">
          {timelineData.map((item, index) => (
            <motion.div
              key={index}
              variants={{
                hidden: { opacity: 0, y: 40 },
                visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } }
              }}
            >
              <TimelineItem>
                <TimelineOppositeContent color="text.secondary">
                  {item.date}
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot sx={{ bgcolor: '#182cd4' }} />
                  {index !== timelineData.length - 1 && <TimelineConnector />}
                </TimelineSeparator>
                <TimelineContent>
                  <Typography>{item.event}</Typography>
                </TimelineContent>
              </TimelineItem>
            </motion.div>
          ))}
        </Timeline>
      </motion.div>
    </Box>
  );
};

export default CompanyHistory;